import { gql } from '@graphql/__generated__';

export const PROPERTY_IMAGE_VERSION_FIELDS = gql(/* GraphQL */ `
  fragment PropertyImageVersionFields on property_image_versions {
    id
    image_id
    source_image_id
    prompt
    created_at
    image {
      id
      url
    }
  }
`);

export const GET_PROPERTY_IMAGES = gql(/* GraphQL */ `
  query GetPropertyImages($property_id: uuid!) {
    watermark_lots: lots(
      where: { property_id: { _eq: $property_id } }
      order_by: { created_at: desc }
    ) {
      ...LotWatermarkEnabled
    }
    property_images(
      where: { property_id: { _eq: $property_id } }
      order_by: { order_nr: asc }
    ) {
      id
      property_id
      title
      description
      display_on_brochure
      display_on_listing
      is_floor_plan
      size
      crop
      background_color
      order_nr
      watermarked_url
      image_id
      image {
        id
        url
      }
      versions(order_by: [{ created_at: asc }, { id: asc }]) {
        ...PropertyImageVersionFields
      }
    }
  }
`);

export const GET_PROPERTY_IMAGES_COUNT = gql(/* GraphQL */ `
  query GetPropertyImagesCount($property_id: uuid!) {
    property_images_aggregate(where: { property_id: { _eq: $property_id } }) {
      aggregate {
        count
      }
    }
  }
`);

export const INSERT_PROPERTY_IMAGE = gql(/* GraphQL */ `
  mutation InsertPropertyImage($object: property_images_insert_input!) {
    insert_property_images_one(object: $object) {
      ...ReportPropertyImage
      display_on_brochure
      display_on_listing
    }
  }
`);

export const INSERT_PROPERTY_IMAGES_BATCH = gql(/* GraphQL */ `
  mutation InsertPropertyImagesBatch(
    $objects: [property_images_insert_input!]!
  ) {
    insert_property_images(objects: $objects) {
      returning {
        id
        property_id
        title
        description
        display_on_brochure
        display_on_listing
        is_floor_plan
        size
        crop
        background_color
        order_nr
        watermarked_url
        image_id
        image {
          id
          url
        }
        versions(order_by: [{ created_at: asc }, { id: asc }]) {
          ...PropertyImageVersionFields
        }
      }
    }
  }
`);

export const DELETE_PROPERTY_IMAGE = gql(/* GraphQL */ `
  mutation DeletePropertyImage($id: uuid!) {
    delete_property_images_by_pk(id: $id) {
      id
    }
  }
`);

export const REORDER_PROPERTY_IMAGES = gql(/* GraphQL */ `
  mutation UpdatePropertyImagesOrder($id: uuid!, $new_order: Int!) {
    update_property_images_by_pk(
      pk_columns: { id: $id }
      _set: { order_nr: $new_order }
    ) {
      id
      order_nr
    }
  }
`);

export const UPDATE_PROPERTY_IMAGE = gql(/* GraphQL */ `
  mutation UpdatePropertyImage(
    $id: uuid!
    $object: property_images_set_input!
  ) {
    update_property_images_by_pk(pk_columns: { id: $id }, _set: $object) {
      id
      title
      description
      display_on_brochure
      display_on_listing
      is_floor_plan
      size
      crop
      background_color
      order_nr
      image {
        id
        url
      }
    }
  }
`);

export const SAVE_PROPERTY_IMAGE_VERSION = gql(/* GraphQL */ `
  mutation SavePropertyImageVersion(
    $propertyImageId: uuid!
    $newImageId: uuid!
    $newImageUrl: String!
    $sourceImageId: uuid
    $prompt: String
    $expectedCurrentImageId: uuid!
  ) {
    save_property_image_version(
      args: {
        property_image_id: $propertyImageId
        new_image_id: $newImageId
        new_image_url: $newImageUrl
        source_image_id: $sourceImageId
        version_prompt: $prompt
        expected_current_image_id: $expectedCurrentImageId
      }
    ) {
      id
      image_id
      watermarked_url
      image {
        id
        url
      }
      versions(order_by: [{ created_at: asc }, { id: asc }]) {
        ...PropertyImageVersionFields
      }
    }
  }
`);

export const ACTIVATE_PROPERTY_IMAGE_VERSION = gql(/* GraphQL */ `
  mutation ActivatePropertyImageVersion(
    $propertyImageId: uuid!
    $targetImageId: uuid!
    $expectedCurrentImageId: uuid!
  ) {
    activate_property_image_version(
      args: {
        property_image_id: $propertyImageId
        target_image_id: $targetImageId
        expected_current_image_id: $expectedCurrentImageId
      }
    ) {
      id
      image_id
      watermarked_url
      image {
        id
        url
      }
      versions(order_by: [{ created_at: asc }, { id: asc }]) {
        ...PropertyImageVersionFields
      }
    }
  }
`);

export const GENERATE_IMAGE_METADATA = gql(/* GraphQL */ `
  query GenerateImageMetadata($property_image_id: uuid!, $language: String) {
    generate_image_metadata(
      property_image_id: $property_image_id
      language: $language
    ) {
      title
      description
    }
  }
`);
